/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import Types from '../constants/actionTypes';
import * as API from '../utils/api';
import { applicationError } from './notificationActions';

export function updateCriteriaStore(response) {
  const { criteria, action, type } = response;
  return (dispatch) => {
    const { parent, type: entityType } = criteria;

    if (entityType === 'Team') {
      dispatch({
        type: Types.RECEIVE_TEAM_CRITERIA,
        teamId: parent,
        criteria
      });
    } else {
      dispatch({
        type: Types.RECEIVE_ACCEPTED_CRITERIA,
        criteria: criteria.accepted,
        parent
      });
      dispatch({
        type: Types.RECEIVE_SUCCESS_CRITERIA,
        criteria: criteria.success,
        parent
      });
    }
    if (action === 'create' || action === 'update') {
      // posts message to CardWall/criteriaView
      // message may not always be received
      // see component event listener for more details
      window.postMessage({ type: 'criteria', action }, window);
    } else if (action === 'delete') {
      // posts message to App.jsx
      // message will always be received
      // see component event listener for more details
      window.postMessage({ type: 'criteria', action, filter: type }, window);
    }
  };
}

export function fetchCriteria(workPackageId, filter) {
  return (dispatch) => {
    let data;
    if (filter === 'success') {
      data = { product_id: workPackageId, filter };
    } else {
      data = { work_package_id: workPackageId, filter };
      if (['ready', 'done', 'shippable'].includes(filter)) {
        dispatch({ type: Types.CLEAR_RESULT_CRITERIA, id: workPackageId });
      }
    }
    dispatch({ type: Types.REQUEST_CRITERIA });
    return API.get('criteria', data)
      .then((response) =>
        dispatch({
          type: Types[`RECEIVE_${filter.toUpperCase()}_CRITERIA`],
          criteria: response
        })
      )
      .catch((error) => dispatch(applicationError(error)));
  };
}

export function fetchTeamCriteria(teamId, filter) {
  return (dispatch) => {
    dispatch({ type: Types.REQUEST_CRITERIA });
    return API.get('criteria', { team_id: teamId, filter })
      .then((response) =>
        dispatch({
          type: Types[`RECEIVE_${filter.toUpperCase()}_CRITERIA`],
          criteria: response
        })
      )
      .catch((error) => dispatch(applicationError(error)));
  };
}

export function fetchResultsCriteria(
  workPackageIds,
  filter,
  crudAction = null
) {
  return (dispatch) => {
    dispatch({ type: Types.REQUEST_CRITERIA });
    return API.post('criteria/index_work_packages_criteria', {
      work_package_ids: workPackageIds,
      filter
    })
      .then((response) => response.json())
      .then((response) => {
        dispatch({
          type: Types[`RECEIVE_${filter.toUpperCase()}_CRITERIA`],
          criteria: response,
          crudAction
        });
      })
      .catch((error) => dispatch(applicationError(error)));
  };
}

export function fulfillCriteria(id, criteriaType, entityIdObject = {}) {
  return (dispatch) => {
    dispatch({ type: Types.REQUEST_CRITERIA });
    return API.put(`criteria/${id}/fulfill`, {
      type: criteriaType,
      ...entityIdObject
    })
      .then((response) => response.json())
      .then((response) =>
        dispatch({
          type: Types[`RECEIVE_${criteriaType.toUpperCase()}_CRITERIA`],
          criteria: [response]
        })
      )
      .catch((error) => dispatch(applicationError(error)));
  };
}

export function unfulfillCriteria(id, criteriaType, entityIdObject = {}) {
  return (dispatch) => {
    dispatch({ type: Types.REQUEST_CRITERIA });
    return API.put(`criteria/${id}/unfulfill`, {
      type: criteriaType,
      ...entityIdObject
    })
      .then((response) => response.json())
      .then((response) =>
        dispatch({
          type: Types[`RECEIVE_${criteriaType.toUpperCase()}_CRITERIA`],
          criteria: [response]
        })
      )
      .catch((error) => dispatch(applicationError(error)));
  };
}

export function createCriteria(data, criteriaType) {
  return (dispatch) => {
    dispatch({ type: Types.REQUEST_CRITERIA });
    return API.post('criteria', data)
      .then((response) => response.json())
      .then((response) => {
        // posts message to CardWall/criteriaView
        // message may not always be received
        // see component event listener for more details
        window.postMessage({ type: 'criteria', action: 'create' }, window);
        dispatch({
          type: Types[`RECEIVE_NEW_${criteriaType.toUpperCase()}_CRITERIA`],
          criteria: response
        });
      })
      .catch((error) => dispatch(applicationError(error)));
  };
}

export function updateCriteria(id, data, criteriaType) {
  return (dispatch) => {
    dispatch({ type: Types.REQUEST_CRITERIA });
    return API.put(`criteria/${id}`, data)
      .then((response) => response.json())
      .then((response) => {
        // posts message to CardWall/criteriaView
        // message may not always be received
        // see component event listener for more details
        window.postMessage({ type: 'criteria', action: 'update' }, window);
        dispatch({
          type: Types[`RECEIVE_${criteriaType.toUpperCase()}_CRITERIA`],
          criteria: [response],
          crudAction: 'update'
        });
      })
      .catch((error) => dispatch(applicationError(error)));
  };
}

export function deleteCriteria(criteria, criteriumType) {
  return (dispatch) => {
    dispatch({ type: Types.REQUEST_CRITERIA });
    return API.del(`criteria/${criteria.id}`, { type: criteriumType })
      .then(() => {
        dispatch({
          type: Types[`DELETE_${criteriumType.toUpperCase()}_CRITERIUM`],
          parent: criteria.work_package_id,
          criteria
        });
      })
      .catch((error) => dispatch(applicationError(error)));
  };
}

export function restoreCriteria(id, criteriaType) {
  return (dispatch) => {
    dispatch({ type: Types.REQUEST_CRITERIA });
    return API.put(`criteria/${id}/restore`)
      .then((response) => response.json())
      .then((response) =>
        dispatch({
          type: Types[`RECEIVE_${criteriaType.toUpperCase()}_CRITERIA`],
          criteria: [response]
        })
      )
      .catch((error) => dispatch(applicationError(error)));
  };
}
